module.exports = __webpack_public_path__ + "c0c43147d60b25a26df9c06cba6b58fd.MP3";